import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MetricCursor from './metric-cursor-model'
import {
  CreateMetricCursorAsync,
  DeleteMetricCursorAsync,
  LoadMetricCursorsAsync,
} from './metricCursor-thunk'
const initialState: metricCursorSliceState = {
  metricCursor: [],
  selected_metricCursor: '',
  is_loading_metricCursor: false,
  is_creating_metricCursor: false,
  is_deleting_metricCursor: false,
}
export interface metricCursorSliceState {
  metricCursor: MetricCursor[]
  selected_metricCursor?: string
  is_loading_metricCursor: boolean
  is_creating_metricCursor: boolean
  is_deleting_metricCursor: boolean
}
export const metricCursorSlice = createSlice({
  name: 'metricCursor',
  initialState,
  reducers: {
    setSelectedmetricCursor: (state, action) => {
      state.selected_metricCursor = action.payload
    },
    clearStatemetricCursor: (state) => {
      state.metricCursor = []
      state.is_loading_metricCursor = false
      state.is_creating_metricCursor = false
      state.is_deleting_metricCursor = false
    },
    mergemetricCursor: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricCursor = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricCursor = merge(state.metricCursor, payload) as any
        }
      }
    },

    add_metricCursor: (state, action) => {
      if (action.payload) {
        state.metricCursor = [...state.metricCursor, action.payload]
      }
    },
    set_metricCursor: (state, action) => {
      let { key, value, id } = action.payload
      state.metricCursor = state.metricCursor.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricCursorsAsync.pending, (state) => {
      state.is_loading_metricCursor = true
    })
    builder.addCase(LoadMetricCursorsAsync.fulfilled, (state, action) => {
      state.is_loading_metricCursor = false
      if (action.payload) {
        state.metricCursor = action.payload
      }
    })
    builder.addCase(LoadMetricCursorsAsync.rejected, (state) => {
      state.is_loading_metricCursor = false
    })
    builder.addCase(CreateMetricCursorAsync.pending, (state) => {
      state.is_creating_metricCursor = true
    })
    builder.addCase(CreateMetricCursorAsync.fulfilled, (state) => {
      state.is_creating_metricCursor = false
    })
    builder.addCase(CreateMetricCursorAsync.rejected, (state) => {
      state.is_creating_metricCursor = false
    })
    builder.addCase(DeleteMetricCursorAsync.pending, (state) => {
      state.is_deleting_metricCursor = true
    })
    builder.addCase(DeleteMetricCursorAsync.fulfilled, (state, action) => {
      state.is_deleting_metricCursor = false
      if (state.metricCursor) {
        state.metricCursor = state.metricCursor.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMetricCursorAsync.rejected, (state) => {
      state.is_deleting_metricCursor = false
    })

    builder.addCase(autoThunks.get_metric_cursors.pending, (state) => {
      state.is_loading_metricCursor = true
    })
    builder.addCase(
      autoThunks.get_metric_cursors.fulfilled,
      (state, action) => {
        state.is_loading_metricCursor = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_metric_cursors.rejected, (state) => {
      state.is_loading_metricCursor = false
    })

    builder.addCase(autoThunks.get_metric_period_cursor.pending, (state) => {
      state.is_loading_metricCursor = true
    })
    builder.addCase(
      autoThunks.get_metric_period_cursor.fulfilled,
      (state, action) => {
        state.is_loading_metricCursor = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_metric_period_cursor.rejected, (state) => {
      state.is_loading_metricCursor = false
    })

    builder.addCase(autoThunks.get_all_metric_cursors.pending, (state) => {
      state.is_loading_metricCursor = true
    })
    builder.addCase(
      autoThunks.get_all_metric_cursors.fulfilled,
      (state, action) => {
        state.is_loading_metricCursor = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_all_metric_cursors.rejected, (state) => {
      state.is_loading_metricCursor = false
    })
  },
})

function handleResult(action: any, state: metricCursorSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_metricCursor = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.metricCursor = merge(state.metricCursor, payload) as any
    }
  }
}

export const {
  clearStatemetricCursor,
  setSelectedmetricCursor,
  set_metricCursor,
  mergemetricCursor,
  add_metricCursor,
} = metricCursorSlice.actions

export const get_metricCursor =
  (id?: string) =>
  (state: {
    metricCursor: {
      metricCursor: MetricCursor[]
    }
  }): MetricCursor | null => {
    let temp = state?.metricCursor?.metricCursor?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.metricCursor?.metricCursor[0] || null
  }
export const get_selected_metricCursor = (state: {
  metricCursor: metricCursorSliceState
}): MetricCursor | null => {
  let id = state?.metricCursor?.selected_metricCursor
  let temp = state?.metricCursor?.metricCursor?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricCursor = (state: {
  metricCursor: {
    metricCursor: MetricCursor[]
  }
}): MetricCursor[] => {
  let temp = state?.metricCursor?.metricCursor
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricCursor_busy = (state: {
  metricCursor: metricCursorSliceState
}) => {
  return (
    state?.metricCursor.is_deleting_metricCursor ||
    state?.metricCursor.is_loading_metricCursor ||
    state?.metricCursor.is_creating_metricCursor
  )
}
export const is_deleting_metricCursor_busy = (state: {
  metricCursor: metricCursorSliceState
}) => {
  return state?.metricCursor.is_deleting_metricCursor
}
export const is_loading_metricCursor_busy = (state: {
  metricCursor: metricCursorSliceState
}) => {
  return state?.metricCursor.is_loading_metricCursor
}
export const is_creating_metricCursor_busy = (state: {
  metricCursor: metricCursorSliceState
}) => {
  return state?.metricCursor.is_creating_metricCursor
}

export default metricCursorSlice.reducer
